import type { FC, SyntheticEvent, ReactNode, ReactElement } from 'react';
import { Tabs, Tab, Box } from '@mui/material';

interface TabItem {
  label: string;
  value: number | string;
  icon?: ReactNode;
}

interface CustomTabsProps {
  id: string;
  tabs: TabItem[];
  value: number | string;
  onChange: (event: SyntheticEvent, newValue: number | string) => void;
  indicatorColor?: 'primary' | 'secondary';
  textColor?: 'primary' | 'secondary' | 'inherit';
  variant?: 'standard' | 'scrollable' | 'fullWidth';
  allowScrollButtonsMobile?: boolean;
  centered?: boolean;
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  children?: ReactNode;
  disabled?: boolean;
  disableFocusRipple?: boolean;
  disableRipple?: boolean;
  iconPosition?: 'start' | 'end' | 'top' | 'bottom';
  wrapped?: boolean;
  selectionFollowsFocus?: boolean;
}

const CustomTabs: FC<CustomTabsProps> = ({
  id,
  tabs,
  value,
  onChange,
  indicatorColor = 'primary',
  textColor = 'primary',
  variant = 'standard',
  allowScrollButtonsMobile = true,
  centered = false,
  orientation = 'horizontal',
  className = '',
  children,
  disabled = false,
  disableFocusRipple = false,
  disableRipple = false,
  iconPosition = 'start',
  wrapped = false,
  selectionFollowsFocus = true,
}) => {
  return (
    <Box className={className}>
      <Tabs
        id={id}
        value={value}
        onChange={onChange}
        indicatorColor={indicatorColor}
        textColor={textColor}
        variant={variant}
        allowScrollButtonsMobile={allowScrollButtonsMobile}
        centered={centered}
        orientation={orientation}
        selectionFollowsFocus={selectionFollowsFocus}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            icon={tab.icon as ReactElement}
            iconPosition={iconPosition}
            disabled={disabled}
            disableFocusRipple={disableFocusRipple}
            disableRipple={disableRipple}
            wrapped={wrapped}
            sx={{ textTransform: 'none' }}
          />
        ))}
      </Tabs>
      {children}
    </Box>
  );
};

export default CustomTabs;
